import { render, staticRenderFns } from "./RequestSuffix.vue?vue&type=template&id=7f47e44a&"
import script from "./RequestSuffix.vue?vue&type=script&lang=js&"
export * from "./RequestSuffix.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports